import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GoalPeriodStatus } from 'src/app/enums/goal-period-status.enum';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-goalperiod-state-change-dialog',
  templateUrl: './goalperiod-state-change-dialog.component.html',
  styleUrl: './goalperiod-state-change-dialog.component.scss'
})
export class GoalPeriodStateChangeDialogComponent implements OnInit {

  public toState: GoalPeriodStatus;
  public fromState: GoalPeriodStatus;
  public contentUrl: string;

  public get isToSelfAssessment(): boolean {
    return this.toState === GoalPeriodStatus.SelfAssessment;
  }

  public get isToLeaderAssessment(): boolean {
    return this.toState === GoalPeriodStatus.LeaderAssessment;
  }

  public get isToFinished(): boolean {
    return this.toState === GoalPeriodStatus.Finished;
  }

  public get isChangeBack(): boolean {
    return this.toState < this.fromState;
  }

  constructor(
    public dialogRef: MatDialogRef<GoalPeriodStateChangeDialogComponent>,
    private languageService: LanguageService,
    @Inject(MAT_DIALOG_DATA) public data: { fromState: GoalPeriodStatus, toState: GoalPeriodStatus }
  ) {
    this.fromState = data.fromState;
    this.toState = data.toState;
  }

  ngOnInit(): void {
      const lang = this.languageService.getCurrentLanguage();
      this.contentUrl = this.getContentUrl(lang);
    }

  public ok() {
    this.dialogRef.close(true);
  }

  private getContentUrl(lang: string): string {
        const fileName = this.getFileName();
        return `/config/html/${lang}/${fileName}_${lang}.html`;
      }
  
  private getFileName(): string {
    if (this.isToSelfAssessment && !this.isChangeBack)
      return 'goal-period-state-to-self-assessment';
    else if (this.isToLeaderAssessment && !this.isChangeBack)
      return 'goal-period-state-to-leader-assessment';
    else if (this.isToFinished && !this.isChangeBack)
      return 'goal-period-state-to-finished';
    else if (this.isChangeBack)
      return 'goal-period-state-change-back';
  }
}
